import React, { useState, useEffect } from 'react';
import AddressTable from './AddressTable'; 
import Menu from './MenuTable';
import DailyMenu from './DailyMenu';
import axiosRestaurantInstance from './AxiosRestaurantInstance';        
import Modal from './Modal';
import AddRestaurant from './AddRestaurant';
import './css/Restaurants.css'; 
// 

const SupRestaurant = () => {
    const [restaurantName, setRestaurantName] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [contactNo, setContactNo] = useState('');
    const [email, setEmail] = useState('');
    const [cuisineType, setCuisineType] = useState('');
    const [notes, setNotes] = useState('');
    const [status, setStatus] = useState('');
    const [addresses, setAddresses] = useState([]);
    const [activeTab, setActiveTab] = useState('menu');
    const [menuItems, setMenuItems] = useState({}); 
    const [foodCategories, setFoodCategories] = useState([]);
    const [showMenuTable, setShowMenuTable] = useState(false); // Manage table display
    const [addedDailyMenuItems, setAddedDailyMenuItems] = useState([]);
    const [dailyMenuItems, setDailyMenuItems] = useState([]);
    const [editingItemId, setEditingItemId] = useState(null); 
    const [tempDailyMenuItem, setTempDailyMenuItem] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false)
        // Retrieve user from localStorage
    const user = JSON.parse(localStorage.getItem('user'));
    // const userId = user ? user.userId : null;

    
    // State for adding a new menu item
    const [showAddMenu, setShowAddMenu] = useState(false);
    const [newMenuItem, setNewMenuItem] = useState({
        foodType: '',
        foodItem: '',
        price: '',
        quantity: '',
        notes: '',
        ingredients: ''
    });

    const handleSearch = async (e) => {
        const searchQuery = e.target.value;
        setRestaurantName(searchQuery);
    
        // Assuming userId is stored in the component's state or passed as a prop
        const userId = user.userId;  // Replace with your actual method of retrieving the userId
        const userRole = user.userRole
        const token = localStorage.getItem('Token')
        if (searchQuery.length > 2 && userId) {
            try {
                const response = await axiosRestaurantInstance.get('/search_restaurant', {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Set the token in the 'Authorization' header
                    },
                    
                    params: { 
                        restaurantName: searchQuery,
                        userId: userId , // Add userId to the params
                        userRole: userRole 
                    }
                });
                setSearchResults(response.data);
            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        }
    };

//--------------------------------- Restaurant Address --------------------------------------------------------

// useEffect(() => {
//         const fetchAddresses = async () => {
//             const userId = user.userId;
//             const token = localStorage.getItem('Token')
//             try {
//                 const response = await axiosRestaurantInstance.get(`/user/${userId}/restaurants`,{
//                     headers: {
//                         'Authorization': `Bearer ${token}`, // Set the token in the 'Authorization' header
//                     }
//             });
                
//                 setAddresses(response.data); // Assuming response.data is the list of addresses
//             } catch (error) {
//                 console.error('Error fetching addresses:', error);
//             }
//         };

//         fetchAddresses();
//     }, [user]);

// const handleEditAddress = (addressId) => {
//     const selectedAddress = addresses.find(address => address.address_id === addressId);
//     if (selectedAddress) {
//         setEditingAddressId(addressId); // Set the address ID for editing
//         setTempAddress({
//             Address_Line_1: selectedAddress.Address_Line_1,
//             Address_Line_2: selectedAddress.Address_Line_2,
//             City: selectedAddress.City,
//             State: selectedAddress.State,
//             Country: selectedAddress.Country,
//             Postal_Code: selectedAddress.Postal_Code,
//             Longitude: selectedAddress.Longitude,
//             Latitude: selectedAddress.Latitude,
//         });
//     }
// };
        
//--------------------------------- DailyMenu API--------------------------------------------------------

const [selectedItem, setSelectedItem] = useState(null); // State for selected row
const [dailyMenuItem, setDailyMenuItem] = useState({
    foodType: '',
    foodItem: '',
    meal:'',
    price: '',
    quantity: '',
    no_of_items_available: '', // User will fill this
    notes: '',
    ingredients: ''
});

const handleSelectItem = (foodItemId) => {
    // Find the selected menu item using foodItemId
    const selectedMenuItem = Object.values(menuItems).flat().find(item => item.Food_Item_Id === foodItemId);

    if (selectedMenuItem) {
        // Set selectedItem to the selected item's ID
        setSelectedItem(foodItemId);

        // Populate dailyMenuItem state with the selected item's data
        setDailyMenuItem({
            foodType: selectedMenuItem.Food_Type,
            foodItem: selectedMenuItem.Food_Item,
            price: selectedMenuItem.Price,
            quantity: selectedMenuItem.Quantity,
            notes: selectedMenuItem.Notes,
            ingredients: selectedMenuItem.Ingredients,
            no_of_items_available: selectedMenuItem.No_of_items_available,
            meal:""
        });
    }
};
const handleDailyMenuChange = (e) => {
    const { name, value } = e.target;
    setDailyMenuItem((prev) => ({
        ...prev,
        [name]: value
    }));
};

const handleAddDailyMenuItem = async (e, itemId) => {
    e.preventDefault();  // Prevent form submission or page reload

    try {
        // Prepare the data for the API
        const newItemData = {
            Restaurant_Id: restaurantId,
            Food_Type: dailyMenuItem.foodType,
            Food_Item: dailyMenuItem.foodItem,
            Meal: dailyMenuItem.meal,
            Price: dailyMenuItem.price.trim(),  // Ensure whitespace is trimmed
            Quantity: dailyMenuItem.quantity.trim(),  // Ensure whitespace is trimmed
            No_of_items_available: dailyMenuItem.No_of_items_available,  // Should be a string as well
            Notes: dailyMenuItem.notes,
            Ingredients: dailyMenuItem.ingredients,
            Created_By_Id: restaurantId
        };

        // Log the data being sent for debugging
        console.log('Sending data to API:', newItemData);
        const token = localStorage.getItem('Token')

        // POST the daily menu item to the API
        const response = await axiosRestaurantInstance.post('/add_daily_menu_item', newItemData,{
            headers: {
                'Authorization': `Bearer ${token}`, // Set the token in the 'Authorization' header
            }
        });

        if (response.status === 201) {
            // Construct the new item in the format expected by the table
            const newItem = {
                Food_Item_Id: response.data.Food_Item_Id, // Assuming the API returns the ID of the new item
                Food_Type: dailyMenuItem.foodType,
                Food_Item: dailyMenuItem.foodItem,
                Meal: dailyMenuItem.meal,
                Price: dailyMenuItem.price,
                Quantity: dailyMenuItem.quantity,
                No_of_items_available: dailyMenuItem.No_of_items_available,
                Notes: dailyMenuItem.notes,
                Ingredients: dailyMenuItem.ingredients
            };

            // Update the state with the new daily menu item
            setDailyMenuItems((prevItems) => [...prevItems, newItem]);

            handleClose(); // Close the row after adding
            alert('Daily menu item added successfully!');
        } else {
            alert('Failed to add daily menu item. Server responded with status: ' + response.status);
        }
    } catch (error) {
        // Log detailed error for debugging
        console.error('Error adding daily menu item:', error.response ? error.response.data : error.message);
        alert('Failed to add daily menu item: ' + (error.response ? error.response.data.message : error.message));
    }
};

const handleClose = () => {
    setSelectedItem(null);
};
    // State for editing menu items
    const [editingItem, setEditingItem] = useState(null);
    
    // New state to store restaurantId
    const [restaurantId, setRestaurantId] = useState(null);

    useEffect(() => {
        // Fetch food categories on component mount
        const fetchFoodCategories = async () => {
            const token = localStorage.getItem('Token')
            const response = await axiosRestaurantInstance.get('/food_categories',{
                headers: {
                    'Authorization': `Bearer ${token}`, // Set the token in the 'Authorization' header
                }
            });
            setFoodCategories(response.data);
        };
        fetchFoodCategories();
    }, []);

    

    const handleEditDailyMenuItem = (dailyItemId) => {
        const selectedItem = dailyMenuItems.find(item => item.Daily_Item_Id === dailyItemId);
        if (selectedItem) {
            setEditingItemId(dailyItemId); // Set the item ID for editing
            setTempDailyMenuItem({
                Food_Type: selectedItem.Food_Type,
                Food_Item: selectedItem.Food_Item,
                Meal:selectedItem.Meal,
                Price: selectedItem.Price,
                Quantity: selectedItem.Quantity,
                Notes: selectedItem.Notes,
                Ingredients: selectedItem.Ingredients,
                No_of_items_available: selectedItem.No_of_items_available,
            });
        }
    };
    const handleUpdateDailyMenuItem = async (dailyItemId) => {
        console.log('Updating item with ID:', dailyItemId);  // Log the item ID
    
        // Check if dailyItemId or tempDailyMenuItem is undefined/null
        if (!dailyItemId || !tempDailyMenuItem) {
            console.error('Daily item ID or temp item data is undefined. Cannot update item.');
            alert('Failed to update daily menu item: Missing data.');
            return; // Exit the function if ID or data is invalid
        }
    
        try {
            // Prepare the data for the API
            const updatedItemData = {
                Food_Type: tempDailyMenuItem.Food_Type,
                Food_Item: tempDailyMenuItem.Food_Item,
                Meal: tempDailyMenuItem.Meal,
                Price: tempDailyMenuItem.Price,
                Quantity: tempDailyMenuItem.Quantity,
                No_of_items_available: tempDailyMenuItem.No_of_items_available,
                Notes: tempDailyMenuItem.Notes,
                Ingredients: tempDailyMenuItem.Ingredients,
            };
    
            // Log the data being sent for debugging
            console.log('Sending data to API for update:', updatedItemData);
    
            // Start the update request
            const token = localStorage.getItem('Token')
            const response = await axiosRestaurantInstance.put(
                `/update_daily_menu_item/${dailyItemId}`,
                updatedItemData,  // Data should be the second argument
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,  // Set the token in headers
                        'Content-Type': 'application/json',  // Ensure JSON format
                    },
                    timeout: 5000,  // Increase timeout (5 seconds)
                }
            );
    
            if (response.status === 200) {
                console.log('Update successful, response data:', response.data);
                
                // Update the state to reflect changes in the UI
                const updatedItems = dailyMenuItems.map(item => 
                    item.Daily_Item_Id === dailyItemId ? { ...item, ...updatedItemData } : item
                );
                setDailyMenuItems(updatedItems);
                setEditingItemId(null); // Exit the editing mode
                alert('Daily menu item updated successfully!');
            } else {
                console.error('Unexpected response status:', response.status);
                alert('Failed to update daily menu item: Unexpected response.');
            }
    
        } catch (error) {
            // Enhanced error handling with network timeout or server issues
            if (error.response) {
                // Server responded with a status code outside the 2xx range
                console.error('Error response from server:', error.response.data);
                alert(`Failed to update daily menu item: ${error.response.data.message || 'Server error'}`);
            } else if (error.request) {
                // Request was made but no response was received
                console.error('No response received:', error.request);
                alert('Failed to update daily menu item: No response from server.');
            } else {
                // Something else caused the error (e.g., network issues)
                console.error('Error:', error.message);
                alert(`Failed to update daily menu item: ${error.message}`);
            }
        }
    };
    
    
    const handleCloseEdit = () => {
        setEditingItemId(null); // Reset to original state without saving
    };
    
    
    const handleDeleteDailyMenuItem = async (dailyItemId) => { // Changed parameter name
        console.log("Deleting item with Daily_Item_Id:", dailyItemId); // Log the correct ID
        try {
            // Make sure to use the correct endpoint that expects Daily_Item_Id
            const token = localStorage.getItem('Token')
            const response = await axiosRestaurantInstance.delete(`/delete_daily_menu_item/${dailyItemId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`

                },
            });
    
            if (response.status === 200) {
                // Remove the item from menuItems state after deletion
                const updatedMenuItems = { ...menuItems };
    
                // Adjust this loop to ensure you're checking against the correct ID
                Object.keys(updatedMenuItems).forEach((foodType) => {
                    updatedMenuItems[foodType] = updatedMenuItems[foodType].filter(item => item.Daily_Item_Id !== dailyItemId); // Use Daily_Item_Id
                });
    
                // Update dailyMenuItems state as well
                setDailyMenuItems(prevItems => prevItems.filter(item => item.Daily_Item_Id !== dailyItemId)); // Use Daily_Item_Id
                setMenuItems(updatedMenuItems);
                setAddedDailyMenuItems(prevState => prevState.filter(item => item !== dailyItemId)); // Assuming this is also adjusted
    
                // Reset actions button back to 'Select'
                setSelectedItem(null);
                alert('Daily menu item deleted successfully!');
            } else {
                // Handle the case where the response is not 200
                const error = await response.json();
                console.error("Error deleting item:", error.error);
            }
        } catch (error) {
            // Handle network errors or other errors
            console.error("Network error:", error);
        }
    };
    

    

    const handleRestaurantSelect = async (restaurant) => {
        setContactNo(restaurant.contactNo);
        setEmail(restaurant.email);
        setCuisineType(restaurant.cuisineType);
        setNotes(restaurant.notes);
        setStatus(restaurant.status);
        setAddresses(restaurant.addresses);
        setRestaurantName(restaurant.restaurantName);
        setRestaurantId(restaurant.restaurantId); // Set restaurantId here
        setSearchResults([]);
        
        const token = localStorage.getItem('Token')
        const menuResponse = await axiosRestaurantInstance.get(`/food_items/${restaurant.restaurantId}`,{
            headers: {
                'Authorization': `Bearer ${token}`, // Set the token in the 'Authorization' header
            }
        });
        setMenuItems(menuResponse.data);

        const dailyMenuResponse = await axiosRestaurantInstance.get(`/daily_menu_items/${restaurant.restaurantId}`,{
            headers: {
                'Authorization': `Bearer ${token}`, // Set the token in the 'Authorization' header
            }
        });
        const dailyMenuItemsArray = Object.values(dailyMenuResponse.data).flat(); // Flatten the grouped items if necessary
        setDailyMenuItems(dailyMenuItemsArray);
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const handleAddMenu = (e) => {
        e.preventDefault(); // Prevent the default form submission
        setShowAddMenu(true);
    };

  const handleAddDailyMenu = () => {
    setShowMenuTable(true); // Display the table when "Add Daily Menu" is clicked
  };

    const handleCloseAddMenu = (e) => {
        e.preventDefault(); // Prevent the default form submission
        setShowAddMenu(false);
        setNewMenuItem({ foodType: '', foodItem: '', price: '', quantity: '', notes: '', ingredients: '' });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewMenuItem({ ...newMenuItem, [name]: value });
    };

    const handleAddNewItem = async (e) => {
        e.preventDefault(); // Prevent default form submission
    
        if (!restaurantId || !newMenuItem.foodType || !newMenuItem.foodItem || !newMenuItem.price) {
            alert("Please fill in all required fields: Food Type, Food Item, and Price.");
            return; // Early exit if validation fails
        }
        const token = localStorage.getItem('Token');
        
    
        try {
            
            const response = await axiosRestaurantInstance.post('/add_food_item', {             
                
                Restaurant_Id: restaurantId,
                Food_Type: newMenuItem.foodType,
                Food_Item: newMenuItem.foodItem,
                Price: newMenuItem.price,
                Quantity: newMenuItem.quantity,
                Notes: newMenuItem.notes,
                Ingredients: newMenuItem.ingredients,  
                Created_By_Id: restaurantId              
            },{
                headers: {
                    'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
                },
            });
    
            if (response.status === 201) {
                const foodItemId = response.data.Food_Item_Id;
    
                const newItem = {
                    Food_Item_Id: foodItemId, // Assign the new item's ID
                    Food_Type: newMenuItem.foodType,
                    Food_Item: newMenuItem.foodItem,
                    Price: newMenuItem.price,
                    Quantity: newMenuItem.quantity,
                    Notes: newMenuItem.notes,
                    Ingredients: newMenuItem.ingredients
                };
    
                setMenuItems((prevItems) => {
                    return {
                        ...prevItems,
                        [newItem.Food_Type]: [...(prevItems[newItem.Food_Type] || []), newItem]
                    };
                });
    
                // Log the new state to verify that Food_Item_Id is present
                console.log('Updated menuItems state after adding:', menuItems);
    
                setShowAddMenu(false);
                setNewMenuItem({ foodType: '', foodItem: '', price: '', quantity: '', notes: '', ingredients: '' });
            }
        } catch (error) {
            // Handle errors
            if (error.response) {
                console.error('Error data:', error.response.data);
                console.error('Error status:', error.response.status);
                alert(`Error: ${error.response.data.error || 'An error occurred while adding the item.'}`);
            } else if (error.request) {
                console.error('Request data:', error.request);
                alert('Error: No response received from the server.');
            } else {
                console.error('Error message:', error.message);
                alert(`Error: ${error.message}`);
            }
        }
    };    

    const handleEditClick = (item) => {
        console.log('Item being passed to edit:', item);
        setEditingItem(item);
    };

    const handleUpdateItem = async (item) => {
        // Log the item being passed to the update function to check for Food_Item_Id
        console.log('Item passed to handleUpdateItem:', item);
    
        try {
            // Check if Food_Item_Id is present
            if (!item.Food_Item_Id) {
                console.error('Missing Food_Item_Id for the item.', item);
                alert('Error: Missing item ID.');
                return;
            }
    
            const updatedItem = {
                Restaurant_Id: item.restaurantId,
                Food_Type: item.foodType,
                Food_Item: item.foodItem,
                Price: item.price,
                Quantity: item.quantity,
                Notes: item.notes,
                Ingredients: item.ingredients
            };
    
            // Send the PUT request to update the item
            const token = localStorage.getItem('Token')
            const response = await axiosRestaurantInstance.put(`/update_food_item/${item.Food_Item_Id}`, updatedItem,{
                headers: {
                    'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
                }
            });
    
            if (response.status === 200) {
                setMenuItems((prevItems) => {
                    const updatedMenuItems = { ...prevItems };
                    Object.keys(updatedMenuItems).forEach(foodType => {
                        updatedMenuItems[foodType] = updatedMenuItems[foodType].map(menuItem => {
                            if (menuItem.Food_Item_Id === item.Food_Item_Id) {
                                return {
                                    ...menuItem,
                                    ...updatedItem
                                };
                            }
                            return menuItem;
                        });
                    });
                    return updatedMenuItems;
                });
    
                setEditingItem(null);  // Clear editing state after successful update
                alert('Food item updated successfully!');
            }
        } catch (error) {
            console.error('Error updating food item:', error.response ? error.response.data : error.message);
            alert(`Error: ${error.response ? error.response.data : 'Unable to update item. Please try again.'}`);
        }
    };
    
    


    const handleDeleteMenuItem = async (foodItemId) => {
        console.log("Deleting food item with ID:", foodItemId); // Debugging
        const token = localStorage.getItem('Token');
    
        try {
            // Send a DELETE request to the backend API
            const response = await axiosRestaurantInstance.delete(`/delete_food_item/${foodItemId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
    
            if (response.status === 200) {
                // Update the menuItems state after deletion
                const updatedMenuItems = { ...menuItems }; // Make a copy of menuItems
    
                // Iterate over the food types and filter out the deleted item
                Object.keys(updatedMenuItems).forEach(foodType => {
                    updatedMenuItems[foodType] = updatedMenuItems[foodType].filter(
                        item => item.Food_Item_Id !== foodItemId
                    );
                });
    
                // Update the state with the filtered menu items
                setMenuItems(updatedMenuItems);
    
                alert('Food item deleted successfully!');
            } else {
                console.error("Error deleting item:", response.data.error);
                alert('Failed to delete the food item.');
            }
        } catch (error) {
            console.error("Network error:", error);
            alert('Network error. Unable to delete food item.');
        }
    };
    
    const handleCancelEdit = () => {
        setEditingItem(null);
    };

    const restaurantId1 = localStorage.getItem("restaurantId");
    const isRestaurantIdValid = restaurantId1 && restaurantId1 !== "null" && restaurantId1 !== "undefined";

    return (
<div className="super-container">
<div className="button-container">
{!isRestaurantIdValid && (
      <button className="add-restaurant-btn" onClick={openModal}>
        Add Restaurant
      </button>
    )}

  </div>

  <Modal isOpen={isModalOpen} onClose={closeModal}>
    <AddRestaurant /> {/* Render AddRestaurant inside the modal */}
  </Modal>
        
    <div className="form-container visible">
        
        <form onSubmit={(e) => e.preventDefault()}>
            <div className="get-restaurant-form-row flex">
                <div className="get-restaurant-form-group">
                    <label>Restaurant Name:</label>
                    <input
                        type="text"
                        value={restaurantName}
                        onChange={handleSearch}
                        placeholder="Enter restaurant name"
                        required
                    />
                    {searchResults.length > 0 && (
                        <ul className={`get-restaurant-dropdown ${searchResults.length ? 'visible' : ''}`}>
                            {searchResults.map((restaurant) => (
                                <li
                                    key={restaurant.restaurantId}
                                    onClick={() => handleRestaurantSelect(restaurant)}
                                >
                                    {restaurant.restaurantName}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <div className="get-restaurant-form-group">
                    <label>Contact Number:</label>
                    <input
                        type="text"
                        value={contactNo}
                        onChange={(e) => setContactNo(e.target.value)}
                    />
                </div>

                <div className="get-restaurant-form-group">
                    <label>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
            </div>

            <div className="get-restaurant-form-row flex">
                <div className="get-restaurant-form-group">
                    <label>Cuisine Type:</label>
                    <input
                        type="text"
                        value={cuisineType}
                        onChange={(e) => setCuisineType(e.target.value)}
                    />
                </div>

                <div className="get-restaurant-form-group">
                    <label>Status:</label>
                    <input
                        type="text"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    />
                </div>

                <div className="get-restaurant-form-group">
                    <label>Notes:</label>
                    <textarea
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    />
                </div>
                </div>

                <h3>Addresses</h3>
                <div style={{ marginBottom: '1  px' }}> {/* Adjust margin as needed */}
                    <AddressTable
                        addresses={addresses}
                        // onEdit={handleEditAddress}
                        // onSave={handleSaveAddress}
                        // onDelete={handleDeleteAddress}
                    />
                </div>

                    {/* Tab headers for Menu and Daily Menu */}
                    <div className="tab-container">
                        <div
                            className={`tab-button ${activeTab === 'menu' ? 'active' : ''}`}
                            onClick={() => handleTabChange('menu')}
                        >
                            Menu
                        </div>
                        <div
                            className={`tab-button ${activeTab === 'dailyMenu' ? 'active' : ''}`}
                            onClick={() => handleTabChange('dailyMenu')}
                        >
                            Daily Menu
                        </div>
                    </div>

                    {/* Tab content */}
                    <div className="tab-content">
                {activeTab === 'menu' && (
                    <Menu
                        showAddMenu={showAddMenu}
                        newMenuItem={newMenuItem}
                        handleInputChange={handleInputChange}
                        handleAddNewItem={handleAddNewItem}
                        handleCloseAddMenu={handleCloseAddMenu}
                        menuItems={menuItems}
                        setMenuItems={setMenuItems} 
                        editingItem={editingItem}
                        handleEditClick={handleEditClick}
                        handleDeleteMenuItem={handleDeleteMenuItem}
                        handleUpdateItem={handleUpdateItem}
                        handleCancelEdit={handleCancelEdit}
                        foodCategories={foodCategories}
                        restaurantId={restaurantId}
                        handleAddMenu={handleAddMenu}
                    />
                
                        )}
{activeTab === 'dailyMenu' && (
    <DailyMenu
        dailyMenuItems={dailyMenuItems}
        handleAddDailyMenu={handleAddDailyMenu}
        editingItemId={editingItemId}
        tempDailyMenuItem={tempDailyMenuItem}
        setTempDailyMenuItem={setTempDailyMenuItem}
        handleUpdateDailyMenuItem={handleUpdateDailyMenuItem}
        handleCloseEdit={handleCloseEdit}
        handleEditDailyMenuItem={handleEditDailyMenuItem}
        handleDeleteDailyMenuItem={handleDeleteDailyMenuItem}
        showMenuTable={showMenuTable}
        menuItems={menuItems}
        addedDailyMenuItems={addedDailyMenuItems}
        selectedItem={selectedItem}
        dailyMenuItem={dailyMenuItem}
        handleDailyMenuChange={handleDailyMenuChange}
        handleAddDailyMenuItem={handleAddDailyMenuItem}
        handleClose={handleClose}
        handleSelectItem={handleSelectItem}
    />
)}


                    </div>
                </form>
            </div>
        </div>
    );
};

export default SupRestaurant;
